import { ServiceResponse } from "../ServiceResponse";

export class UpdateUsernameResponse extends ServiceResponse {
  public UserAlreadyExists: boolean = false;
}
